import { MarketingNav } from "@/components/layout/MarketingNav";
import { MarketingFooter } from "@/components/layout/MarketingFooter";
import { useLocation, useSearchParams } from "react-router-dom";
import { Suspense } from "react";
import { ErrorBoundary } from "@/app/ErrorBoundary";

function LayoutContent({ children }: { children: React.ReactNode }) {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const source = searchParams.get("utm_source");
  const medium = searchParams.get("utm_medium");

  const isAdTraffic = source === "google" || medium === "cpc";
  const isHomeRoute = location.pathname === "/";

  return (
    <div className="min-h-screen w-full flex flex-col">
      {!isAdTraffic && <MarketingNav />}
      <ErrorBoundary resetKey={location.pathname}>{children}</ErrorBoundary>
      {!isAdTraffic && !isHomeRoute && <MarketingFooter />}
    </div>
  );
}

export default function MarketingLayout({ children }: { children: React.ReactNode }) {
  return (
    <Suspense fallback={<div className="min-h-screen w-full flex flex-col">{children}</div>}>
      <LayoutContent>{children}</LayoutContent>
    </Suspense>
  );
}
